import { CountryCode, DEFAULT_COUNTRY_CODE } from "./language";

interface ICountryConfig {
  dixaMessengerToken?: string;
}

export const countryConfig: Record<string, ICountryConfig> = {
  [CountryCode.Danish]: {
    dixaMessengerToken: "dc4f1ab9cb274adb9bafb4c0c450944c",
  },
  [CountryCode.Finnish]: {
    dixaMessengerToken: "7e8473f2abcf4c5c9a1c77da4de8fcef",
  },
};

export const getCountryConfig = (country: string) => {
  const countryCode = country.toUpperCase();
  return countryConfig[countryCode] || countryConfig[DEFAULT_COUNTRY_CODE];
};
